import protoRoot from "../proto-root";

const name = "changeCameraRpcRequest";

function create({ cameraId }) {
  const ChangeCameraRpcRequest = protoRoot.lookupType(
    "comm.ChangeCameraRpcRequest"
  );

  const request = ChangeCameraRpcRequest.create({ cameraId });

  return { payload: request, name };
}

export default {
  create,
  name
};
